import { Action } from "@ngrx/store";

export const LOADING = "[Homes] Loading";
export const UPDATING = "[Homes] Updating";

export class Loading implements Action {
	readonly type = LOADING;
}

export class Updating implements Action {
	readonly type = UPDATING;
}

export type Actions = Loading | Updating;
